export enum kioskDataActionTypes {
  UPDATE_KIOSK_INSTALLATION = 'update_kiosk_installation',
  KIOSK_DATA_RESET = 'kiosk_data_reset',
}
